import React from "react";

export default function PrivacyPolicy() {
  return (
    <main className="min-h-screen bg-[#0b0b0c] text-white">
      <div className="max-w-4xl mx-auto px-6 py-20">

        <h1 className="text-5xl font-bold text-[#ff8c08] mb-10">
          Privacy Policy
        </h1>

        <div className="space-y-8 text-slate-300 leading-relaxed">

          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">
              1. Information We Collect
            </h2>
            <p>
              Filatom may collect information including your phone number,
              profile details, property listings, uploaded images, location
              information, and usage data necessary to provide our services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">
              2. Property Data
            </h2>
            <p>
              Property listings, descriptions, images, pricing information,
              and location data may be stored and displayed publicly to
              facilitate property discovery and transactions.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">
              3. Communication Data
            </h2>
            <p>
              Messages, inquiries, and interactions between users may be
              stored to improve service delivery, platform functionality,
              and user experience.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">
              4. Data Security
            </h2>
            <p>
              We implement reasonable technical and organizational security
              measures designed to protect your personal information from
              unauthorized access, disclosure, alteration, or destruction.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">
              5. Data Sharing
            </h2>
            <p>
              Filatom does not sell personal information. Information may only
              be shared when required by law, legal processes, or when
              necessary for the operation and improvement of our services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">
              6. User Rights
            </h2>
            <p>
              Users may access, update, modify, or request deletion of their
              account information through the Filatom application, subject to
              applicable laws and regulations.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">
              7. Cookies & Analytics
            </h2>
            <p>
              Filatom may use cookies, analytics tools, and similar
              technologies to improve user experience, understand platform
              performance, and enhance our services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">
              8. Policy Updates
            </h2>
            <p>
              Filatom reserves the right to update this Privacy Policy at any
              time. Continued use of the platform constitutes acceptance of
              any changes.
            </p>
          </section>

          <div className="pt-8 border-t border-white/10">
            <p className="text-slate-500">
              Last Updated: June 2026
            </p>
          </div>

        </div>
      </div>
    </main>
  );
}